<h1 mat-dialog-title>Link Patient Medical Scheme</h1>

<div mat-dialog-content class="dialog-content">
    <div class="p-t-20">
        <p class="p-l-10">
            Capturing the correct medical aid/insurance details for a patient enables:
        </p>
        <ul>
            <li>Accurate tariff selection</li>
            <li>Seamless quotations and invoicing</li>
            <li>Accurate patient information for claim submissions</li>
        </ul>
        <!--   <p class="p-l-10">
            These details are encrypted and used exclusively for clinical and billing workflows.
        </p> -->

        <p class="p-l-10"><strong>Current Medical Aid/Insurance Details:</strong></p>
        <ul>
            <li><strong>Medical Aid/Insurance Name:</strong> {{ patient.medicalAid || 'None' }}</li>
            <li><strong>Medical Aid/Insurance Plan:</strong> {{ patient.medicalAidPlan || 'None' }}</li>
            <li><strong>Medical Aid/Insurance Number:</strong> {{ patient.medicalAidNumber || 'None' }}</li>
            <li><strong>Dependant Code:</strong> {{ patient.medicalDependantCode || 'None' }}</li>
            <li><strong>Main Member:</strong> {{ patient.medicalMainMember || 'None' }}</li>
            <li><strong>Gap Cover Name:</strong> {{ patient.gapCover || 'None' }}</li>
            <li><strong>Gap Cover Policy Number:</strong> {{ patient.gapCoverNumber || 'None' }}</li>
        </ul>

        <form [formGroup]="form">

            <app-medical-aid-picker class="m-t-10" [schemes]="schemeReference.schemes"
                [initial]="medicalAidInitial" label="Medical aid/insurance" (pickChange)="pick = $event">
            </app-medical-aid-picker>

            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Medical Aid/Insurance Number</mat-label>
                <input matInput formControlName="medicalAidNumber">
            </mat-form-field>
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Main Member</mat-label>
                <input matInput formControlName="medicalMainMember">
            </mat-form-field>
            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Dependant Code</mat-label>
                <input matInput formControlName="medicalDependantCode">
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Gap Cover Name</mat-label>
                <input matInput formControlName="gapCover">
            </mat-form-field>

            <mat-form-field appearance="outline" class="full-width">
                <mat-label>Gap Cover Policy Number</mat-label>
                <input matInput formControlName="gapCoverNumber">
            </mat-form-field>
        </form>
    </div>
</div>

<div mat-dialog-actions class="dialog-actions">
    <button mat-button mat-dialog-close>
        Skip
    </button>
    <button mat-raised-button color="primary" (click)="linkPatientMedicalAid()">
        Save
    </button>
</div>